import { render, staticRenderFns } from "./botonEditarCualquierPerfil.vue?vue&type=template&id=c6667cdc&"
import script from "./botonEditarCualquierPerfil.vue?vue&type=script&lang=js&"
export * from "./botonEditarCualquierPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports